module.exports = __webpack_public_path__ + "img/thumbnail_NileMonitor_j_albino.bac64a48.png";